import { render, staticRenderFns } from "./ChatbotLanding.vue?vue&type=template&id=e8354460&scoped=true"
import script from "./ChatbotLanding.vue?vue&type=script&lang=js"
export * from "./ChatbotLanding.vue?vue&type=script&lang=js"
import style0 from "./ChatbotLanding.vue?vue&type=style&index=0&id=e8354460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8354460",
  null
  
)

export default component.exports